(function (angular, app) {
    "use strict";

    angular.module(app.modules.scoring.name)
       .controller(app.modules.scoring.routes.scoredetail.controller, ScoreDetailController)

    ScoreDetailController.$inject = ["$scope", "$q", "$routeParams", "ngDialog", "$timeout", "$interval"
       , app.modules.common.services.functions
       , app.modules.common.services.storage
       , app.modules.scoring.services.score
       , app.modules.course.services.search
       , app.modules.ui.services.alerts
       , app.modules.common.constants.equipmentlist
       , app.modules.common.constants.appsettings
    ];

    function ScoreDetailController($scope, $q, $routeParams, ngDialog, $timeout, $interval
       , ggFunctions
       , ggStorage
       , ggScoringSvc
       , ggCourseSvc
       , ggAlertSvc
       , ggEquipmentList
       , ggAppSettings
       ) {

        // Assign this to object so it can be updated from watcher
        var ctrl = this;

        var now = new Date().getTime();

        // Scopes
        $scope.PopupAlert = new ggAlertSvc.popup;
        $scope.Score = null;

        $scope.Temp = {
            isLoaded: false
             , window: ggFunctions.fetchWindowSize()
             , holes: {
                 par: []
             }
             , isClub: false
            , charts: {
                scoring : 
                    {
                        width: 100
                        , height: 100

                    }
            }
        }

        var now = new Date().getTime();


        $scope.Content = {
            init: function () {


                var fetchCourseDetail = function (courseId, teeId) {
                    return ggCourseSvc.search.fetchCourseDetail({ courseId: courseId }).then(function (data) {
                        if (data && data.status == "200") {
                            $scope.Score.Temp.course = data.data[0];
                            if ($scope.Score.teeId > 0 && $scope.Score.Temp.course.tees) {
                                for (var t = 0; t < $scope.Score.Temp.course.tees.length; t++) {
                                    if ($scope.Score.teeId == $scope.Score.Temp.course.tees[t].id) {
                                        var tmpTee = $scope.Score.Temp.course.tees[t];
                                        var holes = tmpTee.holes;
                                        holes.sort(function (a, b) { return a.number - b.number });
                                        tmpTee.holes = holes;
                                        $scope.Score.Temp.tee = tmpTee;
                                        break;
                                    }
                                }
                            }
                        }
                        return;
                    }, function () {
                        return $q.resolve();
                    });
                }


                // Holes Played
                $scope.Score.Temp.holesPlayed = 18;
                if ($scope.Score.holesPlayed != "EighteenHoles") {
                    $scope.Score.Temp.holesPlayed = 9;
                }

                // Check for Hole Stats
                if ($scope.Score.holeScores && $scope.Score.holeScores.length > 0) {
                    for (var s = 0; s < $scope.Score.holeScores.length; s++) {
                        var holeScore = $scope.Score.holeScores[s];
                        if (holeScore.stats && holeScore.stats.golfClub && holeScore.stats.golfClub != "") {
                            $scope.Temp.isClub = true;
                            break;
                        }
                    }
                }

                // Compute Differential ESC Score – Course Rating ) *113 / Slope Rating
                if (!$scope.Score.differential) {
                    $scope.Score.Temp.differential = Math.floor((($scope.Score.esc - $scope.Score.rating) * (113 / $scope.Score.slope)) * 10) / 10;
                } else {
                    $scope.Score.Temp.differential = $scope.Score.differential;
                }
                

                // Chart
                if ($scope.Score.stats){
                    var summary = function () {
                        var ss = [];
                        var labels = [];
                        var solids = [];
                        var borders = [];

                        if (($scope.Score.stats.albatrossCount || 0) > 0) {
                            ss.push($scope.Score.stats.albatrossCount);
                            lables.push("Dbl. Eagles");
                            solids.push(ggAppSettings.colors.chartSolids[0]);
                            borders.push(ggAppSettings.colors.chartSolids[0])
                        }
                        ss.push($scope.Score.stats.eagleCount || 0);
                        labels.push("Eagles");
                        solids.push(ggAppSettings.colors.chartSolids[1]);
                        borders.push(ggAppSettings.colors.chartSolids[1])
                        ss.push($scope.Score.stats.birdieCount || 0);
                        labels.push("Birdies");
                        solids.push(ggAppSettings.colors.chartSolids[2]);
                        borders.push(ggAppSettings.colors.chartSolids[2])
                        ss.push($scope.Score.stats.parCount || 0);
                        labels.push("Pars");
                        solids.push(ggAppSettings.colors.chartSolids[3]);
                        borders.push(ggAppSettings.colors.chartSolids[3])
                        ss.push($scope.Score.stats.bogeyCount || 0);
                        labels.push("Bogeys");
                        solids.push(ggAppSettings.colors.chartSolids[4]);
                        borders.push(ggAppSettings.colors.chartSolids[4])
                        ss.push($scope.Score.stats.doubleCount || 0);
                        labels.push("Doubles");
                        solids.push(ggAppSettings.colors.chartSolids[5]);
                        borders.push(ggAppSettings.colors.chartSolids[5])
                        if (($scope.Score.stats.overDoubleCount || 0) > 0) {
                            ss.push($scope.Score.stats.overDoubleCount);
                            labels.push("Others");
                            solids.push(ggAppSettings.colors.chartSolids[6]);
                            borders.push(ggAppSettings.colors.chartSolids[6])
                        }


                        var ssCnv = document.getElementById("chartScoringSummary").getContext("2d");
                        var ssChart = new Chart(ssCnv, {
                            type: 'doughnut',
                            options: {
                                legend: {
                                    display:false
                                }
                                , responsive: false
                            },
                            data: {
                                labels: labels,
                                datasets: [{
                                    label: 'Scoring',
                                    data: ss,
                                    backgroundColor: solids,
                                    borderColor: borders,
                                    borderWidth: 3
                                }]
                            }
                        });
                    };
                    summary();
                }


                var setupComplete = function () { return $q.resolve() };

                setupComplete().then(function () {
                    if ($scope.Score.id > 0 && (!$scope.Score.localScoreId || ($scope.Score.localScoreId && $scope.Score.localScoreId == 0))) {
                        return fetchCourseDetail($scope.Score.courseId, $scope.Score.teeId);
                    } else {
                        $q.resolve();
                    }
                }).finally(function () {
                    ggFunctions.toggleProcessing(false);
                    ggFunctions.scrollToTop(0);
                    $scope.Temp.isLoaded = true;
                });
            }
        }

        /*
         -------------------------------
         scoped callbacks
         -------------------------------
         */
        $scope.f = {
            formatScoreObject: function () {

                $scope.Score.Temp = {};

                // Check for existing hole scores and populate object w/ 18 records in order
                //if ($scope.Score.Temp.preferenceSettings.postHoleByHole) {
                if (1 == 1) {
                    var aryHoles = angular.copy($scope.Score.holeScores); // save current holes to array
                    var len = aryHoles.length;
                    var hn = 0;

                    var hb = []; // Store current hole numbers
                    if (len > 0) {
                        for (var h = 0; h < len; h++) {
                            hb.push(aryHoles[h].number);
                        }
                    }

                    // Add missing hole objects
                    for (var h = 0; h < 18; h++) {
                        hn++;
                        if (hb.indexOf(hn) == -1) {
                            var holeScore = new app.modules.scoring.objects.holeScore();
                            holeScore.number = hn;
                            aryHoles.push(holeScore);
                        }
                    }

                    // Finally, reorder the holes
                    var arySortedHoles = aryHoles;
                    arySortedHoles.sort(function (a, b) { return a.number - b.number });

                    // Save holes to Score object.
                    $scope.Score.holeScores = arySortedHoles;

                }
                $scope.Temp.isScoreSet = true;
            }
           , getHoleClass: function (holeIndex) {
               var rv = "";
               var holeScore = $scope.Score.holeScores[holeIndex];
               var hole = $scope.Score.Temp.tee.holes[holeIndex];
               if (holeScore && holeScore.gross && hole && hole.par && hole.par > 0) {

                   if (holeScore.gross < (hole.par - 1)) {
                       rv = rv + " eagle";
                   }
                   if (holeScore.gross == (hole.par - 1)) {
                       rv = rv + " birdie";
                   }
                   if (holeScore.gross == (hole.par)) {
                       rv = rv + " par";
                   }
                   if (holeScore.gross == (hole.par + 1)) {
                       rv = rv + " bogey";
                   }
                   if (holeScore.gross == (hole.par + 2)) {
                       rv = rv + " double";
                   }
                   if (holeScore.gross > (hole.par + 2)) {
                       rv = rv + " other";
                   }
               }
               return rv;
           }
           , format: {
               playDate: function (d) {
                   return ggFunctions.formatDateString(d, "m/d/yyyy", null);
               }
              , number: function (n, d) {
                  if (isNaN(n)) {
                      n = 0;
                  }
                  if (isNaN(d)) {
                      d = 0;
                  }

                  n = Math.round(n, d);

                  return n;
              }
              , percent: function (n) {
                  if (isNaN(n)) {
                      n = 0;
                  } else {
                      n = (n * 100);
                  }

                  n = Math.round(n, 1) + "%"
                  return n;
              }
           }
            , stats: {
                getClub: function (hole) {
                    var rv = "";
                    for (var c = 0; c < ggEquipmentList.length; c++) {
                        if (ggEquipmentList[c].name == hole.golfClub) {
                            rv = ggEquipmentList[c].code;
                            break;
                        }
                    }
                    return rv;
                }
                , getFirClass: function (hole) {
                    var rv = ""
                    switch (hole.fir) {
                        case "Hit":
                            rv = "scic scic-fir hit";
                            break;
                        case "MissedUnspecified":
                            rv = "scic scic-fir miss";
                            break;
                        case "MissedRight":
                            rv = "scic scic-fir right";
                            break;
                        case "MissedLeft":
                            rv = "scic scic-fir left";
                            break;
                        case "MissedShort":
                            rv = "scic scic-fir short";
                            break;
                        case "MissedLong":
                            rv = "scic scic-fir long";
                            break;
                    }
                    return rv;
                }
                , getUpDownClass: function (hole) {
                    var rv = "";
                    if (hole.upAndDownOpportunity) {
                        if (hole.sandSaveHit) {
                            rv = "scic scic-sandie hit";
                        } else {
                            rv = "scic scic-sandie miss";
                        }
                    }
                    return rv;
                }
                , getSandieClass: function (hole) {
                    var rv = "";
                    if (hole.sandSaveOpportunity) {
                        if (hole.upAndDownHit){
                            rv = "scic scic-updown hit";
                        }else{
                            rv = "scic scic-updown miss";
                        }
                    }
                    return rv;
                }
            }
        }



        /*
        -------------------------------
        Page Request
        -------------------------------
        */

        if ($routeParams && $routeParams.scoreId) {

            var scoreId = $routeParams.scoreId;
            var score = {};
            var isSetup = false;

            var fetchServerScore = function (scoreId) {
                return ggScoringSvc.scoring.fetchScore({ scoreId: scoreId }).then(function (data) {
                    if (data && data.status == "200") {
                        score = data.data;
                        isSetup = true;
                    }
                    return;
                }, function (error) {
                    return $q.resolve();
                });
            }

            // Process
            ggFunctions.toggleProcessing(true);
            fetchServerScore(scoreId).finally(function () {
                if (!isSetup) {
                    $scope.PopupAlert.fail("Fore!", "The score you requested could not be found.");
                    
                }
                $scope.Score = score;
                $scope.f.formatScoreObject();
                $scope.Content.init();
            });
        } else {
            $scope.PopupAlert.fail("Fore!", "The score you requested could not be found.");
        }

    }
}(angular, app));

